export const EMAIL_REGX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
